/* eslint-disable react/jsx-no-comment-textnodes */
import { ChangeEvent, FC, useEffect, useState } from 'react';
import { EndUserSettingsFormProps, PutSettingsData } from './types';
// import { useForm } from 'react-hook-form';
import { Paper, Grid, Button, TextField, Checkbox, Tooltip } from '@material-ui/core';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import sampleImg from '../../../assets/sample.svg';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { Controller, useForm } from 'react-hook-form';
import { useStore } from 'hooks/useRootStore';
import { useMutation, useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { uid } from 'utils';
export const EndUserConfigForm: FC<EndUserSettingsFormProps> = observer(({ type, description }) => {
  const classes = useStyles();
  const [imgFile, setImgFile] = useState<File | undefined | string>('same');
  const [banFile, setBanFile] = useState<File | undefined | string>('same');
  const [imgSrc, setImgSrc] = useState<string>();
  const [banSrc, setBanSrc] = useState<string>();
  const [imageSize, setImageSize] = useState(true);
  const {
    endUserSettingsFormStore: {
      getSettings,
      settingsByTypeView,
      portalSettings,
      portalSettingsget,
      getShift,
      updateSettings,
      endUserConfigSettings,
    },
    notificationStore: { openNotification },
  } = useStore();
  const portalSettingsReq = useMutation((data: unknown) => portalSettings(data), {
    mutationKey: 'portalSettingsReq',
    onSuccess: (e) => {
      openNotification('success', ` Saved `);
      portalSettingsgetReq.refetch();
      getSettingsReq.refetch();
    },
    onError: (e) => openNotification('error', `${e}`),
  });
  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => portalSettingsget(), {
    onError: () => openNotification('error', `Can't get data`),
  });
  const getSettingsReq = useQuery('getSettingsReq', () => getSettings(), {
    onError: () => openNotification('error', `Can't get settings data`),
  });

  const updateSettingsReq = useMutation((data: PutSettingsData) => updateSettings(data), {
    mutationKey: 'updatePoliciesReq',
    onSuccess: () => openNotification('success', 'Saved!!'),
    onError: () => openNotification('error', `Can't update policies`),
  });

  useAppPreloader(portalSettingsgetReq.isLoading || getSettingsReq.isFetching || updateSettingsReq.isLoading);

  function handleChange(e: { target: { files: (Blob | MediaSource)[] | FileList | any } }) {
    if (e.target.files.length !== 0) {
      setImgFile(e.target.files ? e.target.files[0] : imgFile);
      setImgSrc(URL.createObjectURL(e.target.files[0]));
    }
  }
  function handleBannerChange(e: { target: { files: (Blob | MediaSource)[] | FileList | any } }) {
    if (e.target.files.length !== 0) {
      setBanFile(e.target.files ? e.target.files[0] : banFile);
      setBanSrc(URL.createObjectURL(e.target.files[0]));
    }
  }
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<any>();
  const startDate = watch('startDate');
  const onSubmit = (data: any) => {
    data.companyLogo = imgFile;
    data.bannerImage = banFile;
    if (data.title === '' && data.description === '') {
      const logoOnly = {
        companyLogo: imgFile,
        bannerImage: banFile,
        companyName: data.companyName === undefined ? endUserConfigSettings?.companyName : data.companyName,
        companyUrl: data.companyUrl === undefined ? endUserConfigSettings?.companyUrl : data.companyUrl,
        homeUrl: data.homeUrl === undefined ? endUserConfigSettings?.homeUrl : data.homeUrl,
        contactUrl: data.contactUrl === undefined ? endUserConfigSettings?.contactUrl : data.contactUrl,
        helpUrl: data.helpUrl === undefined ? endUserConfigSettings?.helpUrl : data.helpUrl,
        privacyPolicy: data.privacyPolicy === undefined ? endUserConfigSettings?.privacyPolicy : data.privacyPolicy,
        termOfUse: data.termOfUse === undefined ? endUserConfigSettings?.termOfUse : data.termOfUse,
        data: data.data,
        googleLogin: data.googleLogin === undefined ? endUserConfigSettings?.googleLogin : data.googleLogin,
        googleAuthentication:
          data.googleAuthentication === undefined
            ? endUserConfigSettings?.googleAuthentication
            : data.googleAuthentication,
        userRequest: data.userRequest === undefined ? endUserConfigSettings?.userRequest : data.userRequest,
        profileSelfUpdate:
          data.profileSelfUpdate === undefined ? endUserConfigSettings?.profileSelfUpdate : data.profileSelfUpdate,
      };
      return portalSettingsReq.mutate(logoOnly);
    } else {
      data.companyName = data.companyName === undefined ? endUserConfigSettings?.companyName : data.companyName;
      data.companyUrl = data.companyUrl === undefined ? endUserConfigSettings?.companyUrl : data.companyUrl;
      data.title = data.title === undefined ? endUserConfigSettings?.title : data.title;
      data.startDate = data.startDate === undefined ? endUserConfigSettings?.startDate : data.startDate;
      data.description = data.description === undefined ? endUserConfigSettings?.description : data.description;
      data.endDate = data.endDate === undefined ? endUserConfigSettings?.endDate : data.endDate;
      data.homeUrl = data.homeUrl === undefined ? endUserConfigSettings?.homeUrl : data.homeUrl;
      data.contactUrl = data.contactUrl === undefined ? endUserConfigSettings?.contactUrl : data.contactUrl;
      data.helpUrl = data.helpUrl === undefined ? endUserConfigSettings?.helpUrl : data.helpUrl;
      data.privacyPolicy = data.privacyPolicy === undefined ? endUserConfigSettings?.privacyPolicy : data.privacyPolicy;
      data.termOfUse = data.termOfUse === undefined ? endUserConfigSettings?.termOfUse : data.termOfUse;
      data.googleLogin = data.googleLogin === undefined ? endUserConfigSettings?.googleLogin : data.googleLogin;
      data.googleAuthentication =
        data.googleAuthentication === undefined
          ? endUserConfigSettings?.googleAuthentication
          : data.googleAuthentication;
      data.userRequest = data.userRequest === undefined ? endUserConfigSettings?.userRequest : data.userRequest;
      data.profileSelfUpdate =
        data.profileSelfUpdate === undefined ? endUserConfigSettings?.profileSelfUpdate : data.profileSelfUpdate;
      return portalSettingsReq.mutate(data);
    }
  };

  useEffect(() => {
    setImgSrc(
      !portalSettingsgetReq.isFetching && endUserConfigSettings?.companyLogo
        ? `${endUserConfigSettings?.companyLogo}`
        : sampleImg
    );
    setBanSrc(
      !portalSettingsgetReq.isFetching && endUserConfigSettings?.bannerImage
        ? `${endUserConfigSettings?.bannerImage}`
        : sampleImg
    );

    // Reset form with loaded data
    if (!portalSettingsgetReq.isFetching && endUserConfigSettings) {
      reset({
        companyName: endUserConfigSettings.companyName || '',
        companyUrl: endUserConfigSettings.companyUrl || 'http://',
        googleLogin: endUserConfigSettings.googleLogin || 'false',
        googleAuthentication: endUserConfigSettings.googleAuthentication || 'false',
        userRequest: endUserConfigSettings.userRequest || 'false',
        profileSelfUpdate: endUserConfigSettings.profileSelfUpdate || 'false',
        title: endUserConfigSettings.title || '',
        description: endUserConfigSettings.description || '',
        startDate: endUserConfigSettings.startDate || '',
        endDate: endUserConfigSettings.endDate || '',
        homeUrl: endUserConfigSettings.homeUrl || '',
        contactUrl: endUserConfigSettings.contactUrl || '',
        helpUrl: endUserConfigSettings.helpUrl || '',
        privacyPolicy: endUserConfigSettings.privacyPolicy || '',
        termOfUse: endUserConfigSettings.termOfUse || '',
      });
    }
  }, [
    endUserConfigSettings?.bannerImage,
    endUserConfigSettings?.companyLogo,
    portalSettingsgetReq.isFetching,
    endUserConfigSettings,
    reset,
  ]);

  useEffect(() => {
    document.title = 'EasyIdentity: Settings: Portal';
  }, []);
  const LightTooltip = () => {
    return (
      <div style={{ display: 'flex', height: '50px' }}>
        <LightbulbIcon />
        <span style={{ lineHeight: '10px' }}>Formats: jpeg, gif, bmp, png. File size (max): 2 MB</span>
      </div>
    );
  };
  const BannerTooltip = () => {
    return (
      <div style={{ display: 'flex', height: '50px' }}>
        <LightbulbIcon />
        <span style={{ lineHeight: '10px' }}>Formats: jpeg, gif, bmp, png. File size (max): 5 MB</span>
      </div>
    );
  };
  return (
    <>
      <h1 className={classes.textBox}>Please configure your End-User Portal here.</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        {!portalSettingsgetReq.isLoading && (
          <>
            <Paper className={classes.paper}>
              <Grid spacing={2} container className={classes.heading}>
                <Grid item xs={6} className={classes.companyHeadTitle}>
                  <Controller
                    key='1'
                    name='companyName'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.row}>
                        <TextField
                          {...field}
                          error={invalid}
                          placeholder='Company Name'
                          defaultValue={endUserConfigSettings?.companyName}
                          helperText={invalid ? 'Required field' : ''}
                          className={classes.companytitle}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                </Grid>
                <Grid item xs={6} className={classes.companyHeadTitle}>
                  <Controller
                    key='1'
                    name='companyUrl'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.row}>
                        <TextField
                          {...field}
                          error={invalid}
                          placeholder='Company Url'
                          defaultValue={
                            endUserConfigSettings?.companyUrl ? endUserConfigSettings?.companyUrl : `http://`
                          }
                          helperText={invalid ? 'Required field' : ''}
                          className={` ${classes.cellLink} ${classes.cellLinkhead}`}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                </Grid>
              </Grid>
              <div className={classes.leftCol}>
                <div className={classes.profileContainer}>
                  <img className={classes.profilePicture} src={imgSrc} alt='profile' />
                </div>
                <div className={classes.uploadBtnContainer}>
                  <input
                    accept='image/jpeg,image/gif,image/bmp,image/png'
                    className={classes.input}
                    style={{ display: 'none' }}
                    id='profile-picture'
                    type='file'
                    name='companyLogo'
                    onChange={(event) => {
                      handleChange(event);
                      // const file = (event.target as HTMLInputElement).files?.[0];
                      // if (file) {
                      //   const img = new Image();
                      //   img.src = window.URL.createObjectURL(file);
                      //   img.onload = function () {
                      //     const maxWidth = 400;
                      //     const maxHeight = 400;
                      //     if (img.width > maxWidth || img.height > maxHeight) {
                      //       event.target.value = '';
                      //       setImageSize(false);
                      //       openNotification('error', 'Maximum dimensions allowed are 400px x 400px.');
                      //       (event.target as HTMLInputElement).value = '';
                      //     }
                      //   };
                      // }
                    }}
                    onInput={(event) => {
                      const fileInput = event.target as HTMLInputElement;
                      const file = fileInput.files?.[0];
                      if (file) {
                        const fileType = file.type;
                        const allowedTypes = ['image/jpeg', 'image/bmp', 'image/gif', 'image/png'];
                        if (!allowedTypes.includes(fileType)) {
                          fileInput.value = '';
                          setImageSize(false);
                          openNotification(
                            'error',
                            'Invalid file type. Only JPEG, BMP, PNG and GIF files are allowed.'
                          );
                        } else if (file.size > 2 * 1024 * 1024) {
                          fileInput.value = '';
                          setImageSize(false);
                          openNotification('error', 'Maximum file size allowed is 2 MB.');
                        } else {
                          setImageSize(true);
                        }
                      }
                    }}
                  />
                  <label htmlFor='profile-picture'>
                    <Tooltip title={<LightTooltip />} classes={{ tooltip: classes.tooltip }} arrow placement='top'>
                      <Button component='span' className={classes.link2} variant='contained' color='secondary'>
                        + Upload logo
                      </Button>
                    </Tooltip>
                  </label>
                </div>
                <div className={classes.removeBtnContainer}>
                  <Button
                    className={classes.btnLink}
                    variant='outlined'
                    onClick={() => {
                      setImgFile(undefined);
                      setImgSrc(sampleImg);
                      setImageSize(true);
                    }}
                  >
                    Remove
                  </Button>
                </div>
                <Grid item xs={12} className={classes.btnContainer}>
                  <Button
                    className={classes.submitBtn}
                    type='submit'
                    variant='contained'
                    disabled={imageSize === false}
                  >
                    Save changes
                  </Button>
                </Grid>
              </div>
              <div className={classes.leftCol}>
                <div className={classes.profileContainer}>
                  <img className={classes.profilePicture} src={banSrc} alt='profile' />
                </div>
                <div className={classes.uploadBtnContainer}>
                  <input
                    accept='image/jpeg,image/gif,image/bmp,image/png'
                    className={classes.input}
                    style={{ display: 'none' }}
                    id='banner-picture'
                    type='file'
                    name='bannerImage'
                    onChange={(event) => {
                      handleBannerChange(event);
                      // const file = (event.target as HTMLInputElement).files?.[0];
                      // if (file) {
                      //   const img = new Image();
                      //   img.src = window.URL.createObjectURL(file);
                      //   img.onload = function () {
                      //     const maxWidth = 1100;
                      //     const maxHeight = 2000;
                      //     if (img.width > maxWidth || img.height > maxHeight) {
                      //       event.target.value = '';
                      //       setImageSize(false);
                      //       openNotification('error', 'Maximum dimensions allowed are 1100px x 2000px.');
                      //       (event.target as HTMLInputElement).value = '';
                      //     }
                      //   };
                      // }
                    }}
                    onInput={(event) => {
                      const fileInput = event.target as HTMLInputElement;
                      const file = fileInput.files?.[0];
                      if (file) {
                        const fileType = file.type;
                        const allowedTypes = ['image/jpeg', 'image/bmp', 'image/gif', 'image/png'];
                        if (!allowedTypes.includes(fileType)) {
                          fileInput.value = '';
                          setImageSize(false);
                          openNotification(
                            'error',
                            'Invalid file type. Only JPEG, BMP, PNG and GIF files are allowed.'
                          );
                        } else if (file.size > 2 * 1024 * 1024) {
                          fileInput.value = '';
                          setImageSize(false);
                          openNotification('error', 'Maximum file size allowed is 5 MB.');
                        } else {
                          setImageSize(true);
                        }
                      }
                    }}
                  />
                  <label htmlFor='banner-picture'>
                    <Tooltip title={<BannerTooltip />} classes={{ tooltip: classes.tooltip }} arrow placement='top'>
                      <Button component='span' className={classes.link2} variant='contained' color='secondary'>
                        + Upload Background Image
                      </Button>
                    </Tooltip>
                  </label>
                </div>
                <div className={classes.removeBtnContainer}>
                  <Button
                    className={classes.btnLink}
                    variant='outlined'
                    onClick={() => {
                      setBanFile(undefined);
                      setBanSrc(sampleImg);
                      setImageSize(true);
                    }}
                  >
                    Remove
                  </Button>
                </div>
              </div>
              <TableContainer>
                <Table className={`${classes.border} ${classes.boxes}`} aria-label='simple table'>
                  <TableBody>
                    {settingsByTypeView(type).map((group, i) => (
                      <>
                        {group.settings.map((setting, j) => (
                          <>
                            <Controller
                              key={uid()}
                              name={`data.${getShift(type, i) + j}.key` as const}
                              defaultValue={setting.key}
                              control={control}
                              render={() => <></>}
                            />
                            <Controller
                              key={uid()}
                              name={`data.${getShift(type, i) + j}.value` as const}
                              defaultValue={setting.value}
                              control={control}
                              rules={{ pattern: setting.valueType === 'numeric' ? /^[0-9]+$/ : undefined }}
                              render={({ field, fieldState: { invalid, error } }) => (
                                <TableRow>
                                  <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                                    <p>{setting.description}</p>
                                  </TableCell>
                                  {setting.description === 'Enable Self-Service Account Registration' ? (
                                    <TableCell className={`${classes.border} ${classes.cellLink}`}>
                                      <Checkbox
                                        className={classes.tableCheck}
                                        autoFocus={i === 0}
                                        defaultValue={setting.value || ''}
                                        checked={field.value === '1'}
                                        onChange={(event: ChangeEvent, checked: boolean) =>
                                          field.onChange(`${+checked}`)
                                        }
                                      />
                                      {field.value === '1' && (
                                        <a
                                          target='_blank'
                                          rel='noreferrer'
                                          href={`/register`}
                                          className={classes.linktitle}
                                        >
                                          register
                                        </a>
                                      )}
                                    </TableCell>
                                  ) : (
                                    <TableCell className={`${classes.border} ${classes.cellLink}`}>
                                      <Checkbox
                                        className={classes.tableCheck}
                                        autoFocus={i === 0}
                                        defaultValue={setting.value || ''}
                                        checked={field.value === '1'}
                                        onChange={(event: ChangeEvent, checked: boolean) =>
                                          field.onChange(`${+checked}`)
                                        }
                                      />
                                      {field.value === '1' && (
                                        <a
                                          target='_blank'
                                          rel='noreferrer'
                                          href={`/user/forgot-password`}
                                          className={classes.linktitle}
                                        >
                                          forgot-password
                                        </a>
                                      )}
                                    </TableCell>
                                  )}
                                </TableRow>
                              )}
                            />
                          </>
                        ))}
                      </>
                    ))}
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                        Enable Google Login for Users
                      </TableCell>
                      <TableCell className={classes.border}>
                        <Controller
                          key='1'
                          name='googleLogin'
                          control={control}
                          defaultValue={endUserConfigSettings?.googleLogin}
                          render={({ field }) => (
                            <Grid container className={classes.row}>
                              <Checkbox
                                className={classes.tableCheck}
                                checked={field.value === 'true'}
                                onChange={(event: ChangeEvent<HTMLInputElement>, checked: boolean) =>
                                  field.onChange(checked ? 'true' : 'false')
                                }
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                        Enable 2FA Authentication for Users
                      </TableCell>
                      <TableCell className={classes.border}>
                        <Controller
                          key='1'
                          name='googleAuthentication'
                          control={control}
                          defaultValue={endUserConfigSettings?.googleAuthentication}
                          render={({ field }) => (
                            <Grid container className={classes.row}>
                              <Checkbox
                                className={classes.tableCheck}
                                checked={field.value === 'true'}
                                onChange={(event: ChangeEvent<HTMLInputElement>, checked: boolean) =>
                                  field.onChange(checked ? 'true' : 'false')
                                }
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                        Enable Profile update for end user
                      </TableCell>
                      <TableCell className={classes.border}>
                        <Controller
                          key='1'
                          name='userRequest'
                          control={control}
                          defaultValue={endUserConfigSettings?.userRequest}
                          render={({ field }) => (
                            <Grid container className={classes.row}>
                              <Checkbox
                                className={classes.tableCheck}
                                checked={field.value === 'true'}
                                onChange={(event: ChangeEvent<HTMLInputElement>, checked: boolean) =>
                                  field.onChange(checked ? 'true' : 'false')
                                }
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                        Enable Profile Self-Update
                      </TableCell>
                      <TableCell className={classes.border}>
                        <Controller
                          key='1'
                          name='profileSelfUpdate'
                          control={control}
                          defaultValue={endUserConfigSettings?.profileSelfUpdate}
                          render={({ field }) => (
                            <Grid container className={classes.row}>
                              <Checkbox
                                className={classes.tableCheck}
                                checked={field.value === 'true'}
                                onChange={(event: ChangeEvent<HTMLInputElement>, checked: boolean) =>
                                  field.onChange(checked ? 'true' : 'false')
                                }
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>End-User Portal Link</TableCell>
                      <TableCell className={`${classes.border} ${classes.cellLink}`}>
                        <a
                          target='_blank'
                          rel='noreferrer'
                          href={`/login`}
                          onClick={() => {
                            localStorage.removeItem('connection');
                          }}
                          className={classes.linktitle}
                        >
                          Portal
                        </a>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                        Alert Title Text on the Login Page
                      </TableCell>
                      <TableCell className={classes.border}>
                        <Controller
                          key='1'
                          name='title'
                          // defaultValue={profileInfo?.[item.name]}
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                // label='alert'
                                // disabled={item.disabled}
                                error={invalid}
                                placeholder='Alert Title'
                                defaultValue={endUserConfigSettings?.title}
                                helperText={invalid ? 'Required field' : ''}
                                className={classes.input}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                        Alert Message on the Login Page
                      </TableCell>
                      <TableCell className={classes.border}>
                        <Controller
                          key='1'
                          name='description'
                          // defaultValue={profileInfo?.[item.name]}
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                // label='alert'
                                // disabled={item.disabled}
                                error={invalid}
                                placeholder='Alert Text'
                                defaultValue={endUserConfigSettings?.description}
                                helperText={invalid ? 'Required field' : ''}
                                className={classes.input}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                        Activation Date for the Alert Message on the Login Page
                      </TableCell>
                      <TableCell className={classes.border}>
                        <Controller
                          key='startDate'
                          name='startDate'
                          control={control}
                          render={({ field }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                type='date'
                                error={!!errors.startDate}
                                defaultValue={endUserConfigSettings?.startDate}
                                placeholder='Start Date'
                                helperText={errors.startDate ? 'Start date is required' : ''}
                                className={classes.input}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                        Valid Until Date for the Alert Message on the Login Page
                      </TableCell>
                      <TableCell className={classes.border}>
                        <Controller
                          key='endDate'
                          name='endDate'
                          control={control}
                          rules={{
                            validate: (value) => {
                              return (
                                !value ||
                                !startDate ||
                                new Date(value) > new Date(startDate) ||
                                'End date must be after start date'
                              );
                            },
                          }}
                          render={({ field }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                type='date'
                                error={!!errors.endDate}
                                defaultValue={endUserConfigSettings?.endDate}
                                placeholder='End Date'
                                helperText={errors.endDate?.message?.toString() ?? ''}
                                className={classes.input}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>Home</TableCell>
                      <TableCell className={`${classes.border} ${classes.cellLink}`}>
                        <Controller
                          key='1'
                          name='homeUrl'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Home Url'
                                defaultValue={endUserConfigSettings?.homeUrl ? endUserConfigSettings?.homeUrl : ''}
                                helperText={invalid ? 'Required field' : ''}
                                className={`${classes.input} ${classes.cellInputLink}`}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>Contact Us</TableCell>
                      <TableCell className={`${classes.border} ${classes.cellLink}`}>
                        <Controller
                          key='1'
                          name='contactUrl'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Contact Url'
                                defaultValue={
                                  endUserConfigSettings?.contactUrl ? endUserConfigSettings?.contactUrl : ``
                                }
                                helperText={invalid ? 'Required field' : ''}
                                className={`${classes.input} ${classes.cellInputLink}`}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>Help</TableCell>
                      <TableCell className={`${classes.border} ${classes.cellLink}`}>
                        <Controller
                          key='1'
                          name='helpUrl'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Help Url'
                                defaultValue={endUserConfigSettings?.helpUrl ? endUserConfigSettings?.helpUrl : ``}
                                helperText={invalid ? 'Required field' : ''}
                                className={`${classes.input} ${classes.cellInputLink}`}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>Privacy Policy</TableCell>
                      <TableCell className={`${classes.border} ${classes.cellLink}`}>
                        {' '}
                        <Controller
                          key='1'
                          name='privacyPolicy'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Privacy Url'
                                defaultValue={
                                  endUserConfigSettings?.privacyPolicy ? endUserConfigSettings?.privacyPolicy : ``
                                }
                                helperText={invalid ? 'Required field' : ''}
                                className={`${classes.input} ${classes.cellInputLink}`}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>Terms of Use</TableCell>
                      <TableCell className={`${classes.border} ${classes.cellLink}`}>
                        {' '}
                        <Controller
                          key='1'
                          name='termOfUse'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Term Url'
                                defaultValue={endUserConfigSettings?.termOfUse ? endUserConfigSettings?.termOfUse : ``}
                                helperText={invalid ? 'Required field' : ''}
                                className={`${classes.input} ${classes.cellInputLink}`}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </>
        )}
      </form>
    </>
  );
});
